((document, Drupal) => {
  "use strict";
  Drupal.behaviors.teamgroup = {
    attach: (context) => {
      if (context === document) {
        if (!document.querySelector('.team-group')) return;


        Array.prototype.slice.call(once('bind-click-event', '.team-group__item-text', context)).forEach(function (teamGroupText) {
          const toggleButton = teamGroupText.getElementsByTagName('button')[0];
          const blurb = teamGroupText.querySelector('.team-group__item-blurb');
          if(blurb.offsetHeight >= 75) {
            blurb.classList.add("compressed");
            blurb.style.maxHeight = `75px`;
          }

          var ro = new ResizeObserver(entries => {
            for (let entry of entries) {
              const cr = entry.contentRect;
              if(cr.height >= 75) {
                toggleButton.classList.remove("hidden");
              } else {
                toggleButton.setAttribute('text', 'Read Less');
                toggleButton.classList.add("hidden");
                blurb.classList.remove("compressed");
              }
            }
          });

          ro.observe(blurb);
          toggleButton.addEventListener('click', function (event) {
            if (blurb.classList.contains("compressed")) {
              blurb.classList.remove("compressed");
              blurb.style.maxHeight = `${blurb.scrollHeight}px`;
              toggleButton.setAttribute('text', 'Read Less');
            } else {
              blurb.classList.add("compressed");
              blurb.style.maxHeight = `75px`;
              toggleButton.setAttribute('text', 'Read More');
            }
          });
        });


      }
    }
  }
})(document, Drupal);
